import { useEffect, useState, useSyncExternalStore } from 'react';
import { useAuth } from '../AuthContext.jsx';
import { supabase } from '../supabase.js';
import { isSaved, loadSavedKeys, savedKindFor, subscribeSaved, toggleSavedJob } from './saved.js';

/** Bookmark for one web listing. `kind` is the web feed kind: 'job' | 'home_job' | 'tender'. */
export function SaveListingButton({ kind, id, title = 'this job' }) {
  const { user } = useAuth();
  const savedKind = savedKindFor[kind] || kind;
  const saved = useSyncExternalStore(subscribeSaved, () => isSaved(savedKind, id), () => false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { void loadSavedKeys(supabase, user?.id ?? null); }, [user?.id]);
  if (!user || !supabase) return null;
  const toggle = async () => {
    setBusy(true); setError('');
    try { await toggleSavedJob(supabase, savedKind, id); }
    catch (cause) { setError(cause.message); }
    finally { setBusy(false); }
  };
  return <span className="saved-toggle">
    <button type="button" className={`button button-secondary${saved ? ' saved' : ''}`} aria-pressed={saved} disabled={busy}
      aria-label={saved ? `Remove ${title} from saved` : `Save ${title}`} onClick={toggle}>{saved ? 'Saved' : 'Save'}</button>
    {error && <small role="alert">{error}</small>}
  </span>;
}
